<template>
  <CFlex
    align="baseline"
    :class="{
      'tile-container': hasCountainer,
      'has-hover-effect': hasHoverEffect
    }"
    @click="handleClick"
  >
    <CFlex w="100%">
      <OmtIcons :name="icon" size="lg"
color="#4E4E4E" />
      <CStack class="labels-container" ml="4">
        <OmtTypography v-if="!!title" as="h3-bold">{{ title }}</OmtTypography>
        <OmtTypography v-if="subtitle" as="p2"
color="#8C8C8C">{{ subtitle }}</OmtTypography>
        <omt-p v-if="!!description" v-chakra>
          {{ description }}
        </omt-p>
      </CStack>
    </CFlex>
    <CFlex class="lead-icons-container">
      <CBox v-for="(leadIcon, index) in leadIcons" :key="index"
:ml="index !== 0 && '4'">
        <i :class="`${leadIcon} fa-lg`" />
      </CBox>
    </CFlex>
  </CFlex>
</template>

<script>
import { CFlex, CStack, CBox } from "@chakra-ui/vue";

export default {
  name: "AffiliateIndicationTile",
  components: {
    CFlex,
    CStack,
    CBox
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    hasCountainer: Boolean,
    hasHoverEffect: Boolean,
    title: String,
    description: String,
    link: String,
    leadIcons: Array,
    subtitle: String
  },
  methods: {
    handleClick() {
      if (this.link) this.$router.push(this.link);
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.labels-container {
  gap: 6px;
}

.has-hover-effect {
  transition: opacity 0.5s ease;

  &:hover {
    opacity: 0.6;
    cursor: pointer;
  }
}

p {
  margin: 0 !important;
}
.tile-container {
  padding: 1rem;
  border: 0.5px solid #dadada;
  border-radius: 8px;
}
.lead-icons-container {
  margin-left: auto;
  width: 100%;
  flex: 1;
}
.dark .tile-container {
  background-color: #1f1f1f;
}
</style>
